export default __webpack_public_path__ + "static/media/appointments_6.f640defb.jpg";